/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import i18n from '@fai/friendli-suite/features/i18n';
import { ClientTeamMembershipRole } from '@fai/friendli-suite/generated/client/graphql';
import type { Nullish } from '@fai/util/types';

export const getTeamMembershipRoleI18n = (role: Nullish<ClientTeamMembershipRole>) => {
  switch (role) {
    case ClientTeamMembershipRole.Admin: {
      return {
        name: i18n.t('team_settings.admin'),
        description: i18n.t('team_settings.admin_description'),
      };
    }
    case ClientTeamMembershipRole.Owner: {
      return {
        name: i18n.t('team_settings.owner'),
        description: i18n.t('team_settings.owner_description'),
      };
    }
    case ClientTeamMembershipRole.Member: {
      return {
        name: i18n.t('team_settings.member'),
        description: i18n.t('team_settings.member_description'),
      };
    }

    // TODO: cover Billing and default case
  }
};

export const TeamMembershipRolePermissions = (role: Nullish<ClientTeamMembershipRole>) => {
  return {
    isTeamOwner: role === ClientTeamMembershipRole.Owner,
    isRoleUpdatable: !(
      role === ClientTeamMembershipRole.Owner || role === ClientTeamMembershipRole.Billing
    ),
    isAboveAdmin:
      role === ClientTeamMembershipRole.Owner || role === ClientTeamMembershipRole.Admin,
  };
};
